import { EntityLinks, Goal, ID } from '@griply/types';

import { getSubGoals } from './get-sub-goals';
import { createGoalTreeIndex } from './goal-tree-index';
import { isTaskMeasuredGoal } from './is-task-measured-goal';

// Progress rolls sub-goal tasks up, so a task-measured goal needs its whole sub-tree loaded.
// `links` is required: without it a migrated sub-goal is never found, so its tasks are never
// subscribed and the parent's progress count reads low.
export const getGoalProgressGoalIds = (
  goals: Goal[],
  links: EntityLinks,
): ID[] => {
  const progressGoals = goals.filter(isTaskMeasuredGoal);

  if (!progressGoals.length) {
    return [];
  }

  // Shared so getSubGoals doesn't rebuild the parent map per project.
  const index = createGoalTreeIndex(goals, { links });

  const ids = new Set<ID>();
  progressGoals.forEach((goal) => {
    ids.add(goal.id);
    getSubGoals(goal.id, { goals, recursive: true, index, links }).forEach(
      ({ id }) => ids.add(id),
    );
  });

  return [...ids];
};
